import moment from 'moment';
import Api from '../../services/Api';
import Helpers from '../../js/helpers';
import EventBus from '../../js/event-bus';

const getDefaultState = () => ({
  newProject: {},
  analysis_recient: ['Si', 'No'],
  methodPlantation: ['Trasplante', 'Siembra'],
  stationClimate: [{ id: 'Añadir', source: 'Añadir' }],
  project_equation: ['ALMERIA', 'HARGREAVES'],
  cropMedium: ['Suelo'], // En un futuro añadir , 'Sustrato'
  ground: [],
  WithouWhitewashing: [{ id: 0.45, type: 'Ligero (0.45)' }, { id: 0.30, type: 'Medio (0.30)' }, { id: 0.20, type: 'Intenso (0.20)' }],
  enabledPopUpFloor: false,
  enabledPopUpIrrigation: false,
  irrigation: [],
  manure: [],
  enabledPopUpManure: false,
  textures: [{ id: 'Añadir', name: 'Añadir' }],
  typesFloor: [],
  province: null,
  climate: [],
  climateSource: null,
  unit: [{ name: 'mg/Kg', id: 'MG' }, { name: 'meq/100g', id: 'MEQ' }],
  unitCe: [{ name: 'dS/m', id: 'DS' }, { name: 'mmhos/cm', id: 'MICROS' }],
  listCropGH: [],
  whitewashed: [],
  dataSourceWhiteWashingAdded: [],
  provinces: [],
  enabledPopUpStation: false,
  cont: 0,
  attachment: null,
});

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    resetProjectGreenHouse({ commit }) {
      commit('resetProjectGreenHouse');
    },
    setNameProject(context, value) {
      context.commit('setNameProject', value);
    },
    setSizeGreenHouse(context, value) {
      context.commit('setSizeGreenHouse', value);
    },
    setProvince(context, value) {
      context.commit('setProvince', value);
    },
    setDatabaseProvince(context, value) {
      context.commit('setDatabaseProvince', value);
    },
    setStation(context, value) {
      context.commit('setStation', value);
    },
    setStationType(context, value) {
      context.commit('setStationType', value);
    },
    setClimateId(context, value) {
      context.commit('setClimateId', value);
    },
    setCrop(context, value) {
      context.commit('setCrop', value);
    },
    setCropMedium(context, value) {
      context.commit('setCropMedium', value);
    },
    setDateTransplanting(context, value) {
      context.commit('setDateTransplanting', value);
    },
    setDateEndCrop(context, value) {
      context.commit('setDateEndCrop', value);
    },
    setMethodPlantation(context, value) {
      context.commit('setMethodPlantation', value);
    },
    setFloor(context, value) {
      context.commit('setFloor', value);
    },
    setEnabledPopUpFloor(context, value) {
      context.commit('setEnabledPopUpFloor', value);
    },
    setNitricNitrogen(context, value) {
      context.commit('setNitricNitrogen', value);
    },
    setPhosphorus(context, value) {
      context.commit('setPhosphorus', value);
    },
    setAnalysisRecient(context, value) {
      context.commit('setAnalysisRecient', value);
    },
    setAnalysisPreview(context, value) {
      context.commit('setAnalysisPreview', value);
    },
    setAnalysisPotasio(context, value) {
      context.commit('setAnalysisPotasio', value);
    },
    setAnalysisPotasioUnit(context, value) {
      context.commit('setAnalysisPotasioUnit', value);
    },
    setAnalysisCalcio(context, value) {
      context.commit('setAnalysisCalcio', value);
    },
    setAnalysisCalcioUnit(context, value) {
      context.commit('setAnalysisCalcioUnit', value);
    },
    setAnalysisMagnesio(context, value) {
      context.commit('setAnalysisMagnesio', value);
    },
    setAnalysisMagnesioUnit(context, value) {
      context.commit('setAnalysisMagnesioUnit', value);
    },
    setAnalysisSodio(context, value) {
      context.commit('setAnalysisSodio', value);
    },
    setAnalysisSodioUnit(context, value) {
      context.commit('setAnalysisSodioUnit', value);
    },
    setIrrigationConfiguration(context, value) {
      context.commit('setIrrigationConfiguration', value);
    },
    setWhiteWashing(context, value) {
      context.commit('setWhiteWashing', value);
    },
    setEnabledPopUpIrrigation(context, value) {
      context.commit('setEnabledPopUpIrrigation', value);
    },
    setEnabledPopUpManure(context, value) {
      context.commit('setEnabledPopUpManure', value);
    },
    setManureSelected(context, value) {
      context.commit('setManureSelected', value);
    },
    setAnalysisPhosphorusUnit(context, value) {
      context.commit('setAnalysisPhosphorusUnit', value);
    },
    setAnalysisNitrogesUnit(context, value) {
      context.commit('setAnalysisNitrogesUnit', value);
    },
    setCeFloor(context, value) {
      context.commit('setCeFloor', value);
    },
    setCeFloorUnit(context, value) {
      context.commit('setCeFloorUnit', value);
    },
    resetNewProject(context, value) {
      context.commit('resetNewProject', value);
    },
    addElementoInFloor(context, value) {
      context.commit('addElementoInFloor', value);
    },
    addElementoInIrrigation(context, value) {
      context.commit('addElementoInIrrigation', value);
    },
    addElementoManure(context, value) {
      context.commit('addElementoManure', value);
    },
    addElementInTextures(context, value) {
      context.commit('addElementInTextures', value);
    },
    setAnalysisAvailables(context, value) {
      context.commit('setAnalysisAvailables', value);
    },
    setIrrigationFloorUnit(context, value) {
      context.commit('setIrrigationFloorUnit', value);
    },
    setApplicationDateManure(context, value) {
      context.commit('setApplicationDateManure', value);
    },
    setVolAplicated(context, value) {
      context.commit('setVolAplicated', value);
    },
    setDataSourceWhiteWashingAdded(context, value) {
      context.commit('setDataSourceWhiteWashingAdded', value);
    },
    setWhitewashed(context, value) {
      context.commit('setWhitewashed', value);
    },
    setCeWaterGround(context, value) {
      context.commit('setCeWaterGround', value);
    },
    loadProject(context, value) {
      context.commit('loadProject', value);
    },
    setGroundConcated(context, value) {
      context.commit('setGroundConcated', value);
    },
    setManureConcated(context, value) {
      context.commit('setManureConcated', value);
    },
    setIrrigationConcated(context, value) {
      context.commit('setIrrigationConcated', value);
    },
    setEquation(context, value) {
      context.commit('setEquation', value);
    },
    setEnabledPopUpStation(context, value) {
      context.commit('setEnabledPopUpStation', value);
    },
    setCont(context, value) {
      context.commit('setCont', value);
    },
    setAttachment(context, value) {
      context.commit('setAttachment', value);
    },
    async fetchListCrop(context, value) {
      try {
        const xhr = await Api.fetchListCrop();
        const listCropGH = [];
        const dataCultives = JSON.parse(xhr.response);
        for (const cultive of dataCultives) {
          if (cultive.type === 'GH') listCropGH.push(cultive);
        }
        context.commit(
          'fetchListCrop',
          listCropGH.sort((a, b) => ((a.name > b.name) ? 1 : -1)),
        );
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async createNewProject({ state }) {
      try {
        const manure = Helpers.parseManure(state.newProject.manure);
        if (!state.newProject.name) {
          throw new Error('El campo "Nombre del proyecto" es requerido.');
        }
        // if (state.newProject.area <= 0) {
        //   throw new Error('El campo "Tamaño parcela" es requerido.');
        // }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.weather_source && !state.newProject.climate_id) {
          throw new Error('El campo "Estación agroclimática" es requerido.');
        }
        if (!state.newProject.cultive.crop_id) {
          throw new Error('El campo "Cultivo" es requerido.');
        }
        if (!state.newProject.cultive.crop_type) {
          throw new Error('El campo "Medio de cultivo" es requerido.');
        }
        if (!state.newProject.cultive.date_init) {
          throw new Error('El campo "Fecha de siembra" es requerido.');
        }
        if (!state.newProject.cultive.date_end) {
          throw new Error('El campo "Fecha prevista fin de cultivo" es requerido.');
        }
        if (!state.newProject.ground.ground_id) {
          throw new Error('El campo "Suelo" es requerido.');
        }
        if (!state.newProject.irrigation.irrigation_id) {
          throw new Error('El campo "Configuración de riego" es requerido.');
        }
        if (!state.newProject.irrigation.equation) {
          throw new Error('El campo "Ecuación ET₀" es requerido.');
        }
        const whitewashedFormat = [];
        if (state.newProject.whitewashed) {
          state.newProject.whitewashed.forEach((item) => {
            whitewashedFormat.push({
              transmittance: item.transmittance,
              application_date: moment(item.aplicationDate ? item.aplicationDate : item.application_date).format('YYYY-MM-DD'),
              wash_date: moment(item.washingDate ? item.washingDate : item.wash_date).format('YYYY-MM-DD'),
            });
          });
        }
        const allDataNewProject = {
          name: state.newProject.name,
          type: 'GH',
          // area: state.newProject.area,
          province: state.newProject.province,
          weather_source: state.newProject.weather_source,
          weather_source_type: state.newProject.weather_source_type,
          climate_id: state.newProject.climate_id === 'Año medio'
            ? null : state.newProject.climate_id,
          cultive: {
            crop_id: state.newProject.cultive.crop_id,
            date_init: moment(state.newProject.cultive.date_init).format('YYYY-MM-DD'),
            date_end: moment(state.newProject.cultive.date_end).format('YYYY-MM-DD'),
            crop_type: state.newProject.cultive.crop_type,
            density: null,
          },
          ground: {
            ground_id: state.newProject.ground.ground_id,
            recent_analysis: state.newProject.ground.recent_analysis === 'Yes',
            previous_analysis: state.newProject.ground.previous_analysis === 'Yes',
            P: state.newProject.ground.P ? state.newProject.ground.P : 250,
            K: state.newProject.ground.K ? state.newProject.ground.K : 240,
            N: state.newProject.ground.N ? state.newProject.ground.N : 25,
            Mg: state.newProject.ground.Mg ? state.newProject.ground.Mg : 225,
            Ca: state.newProject.ground.Ca ? state.newProject.ground.Ca : 1000,
            Na: state.newProject.ground.Na ? state.newProject.ground.Na : 58,
            ce: state.newProject.ground.ce ? state.newProject.ground.ce : 3,
            P_units: state.newProject.PhosphorusUnit
              ? state.newProject.PhosphorusUnit : state.unit[0].id,
            K_units: state.newProject.potasioUnit ? state.newProject.potasioUnit : state.unit[0].id,
            N_units: state.newProject.NitrogesUnit
              ? state.newProject.NitrogesUnit : state.unit[0].id,
            Mg_units: state.newProject.magnesioUnit
              ? state.newProject.magnesioUnit : state.unit[0].id,
            Ca_units: state.newProject.calcioUnit ? state.newProject.calcioUnit : state.unit[0].id,
            Na_units: state.newProject.sodioUnit ? state.newProject.sodioUnit : state.unit[0].id,
            ce_units: state.newProject.ceFloorUnit
              ? state.newProject.ceFloorUnit : state.unitCe[0].id,
          },
          ground_external: null,
          irrigation: {
            irrigation_id: state.newProject.irrigation.irrigation_id,
            analysis: state.newProject.irrigation.analysis,
            ce: null,
            units_ce: null,
            et0_ecuation: state.newProject.irrigation.equation,
            line_distance: null,
            drip_distance: null,
            caudal: null,
            efficiency: null,
            n_water: null,
            irrigation_open_air: null,
          },
          whitewashed: whitewashedFormat,
          manure,
        };
        try {
          await Api.createNewProject(allDataNewProject);
        } catch (e) {
          console.error(e);
          return Promise.reject(new Error('¡Upss ha ocurrido un error! Por favor verifique sus datos.'));
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async updateProject({ state }) {
      try {
        const manure = Helpers.parseManure(state.newProject.manure);
        if (!state.newProject.name) {
          throw new Error('El campo "Nombre del proyecto" es requerido.');
        }
        // if (state.newProject.area <= 0) {
        //   throw new Error('El campo "Tamaño parcela" es requerido.');
        // }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.province) {
          throw new Error('El campo "Provincia" es requerido.');
        }
        if (!state.newProject.weather_source && !state.newProject.climate_id) {
          throw new Error('El campo "Estación agroclimática" es requerido.');
        }
        if (!state.newProject.cultive.crop_id) {
          throw new Error('El campo "Cultivo" es requerido.');
        }
        if (!state.newProject.cultive.crop_type) {
          throw new Error('El campo "Medio de cultivo" es requerido.');
        }
        if (!state.newProject.cultive.date_init) {
          throw new Error('El campo "Fecha de siembra" es requerido.');
        }
        if (!state.newProject.cultive.date_end) {
          throw new Error('El campo "Fecha prevista fin de cultivo" es requerido.');
        }
        if (!state.newProject.ground.ground_id) {
          throw new Error('El campo "Suelo" es requerido.');
        }
        if (!state.newProject.irrigation.irrigation_id) {
          throw new Error('El campo "Configuración de riego" es requerido.');
        }
        if (!state.newProject.irrigation.equation) {
          throw new Error('El campo "Ecuación ET₀" es requerido.');
        }
        const whitewashedFormat = [];
        if (state.newProject.whitewashed) {
          state.newProject.whitewashed.forEach((item) => {
            whitewashedFormat.push({
              transmittance: item.transmittance,
              application_date: moment(item.aplicationDate ? item.aplicationDate : item.application_date).format('YYYY-MM-DD'),
              wash_date: moment(item.washingDate ? item.washingDate : item.wash_date).format('YYYY-MM-DD'),
            });
          });
        }
        const allDataNewProject = {
          name: state.newProject.name,
          type: 'GH',
          // area: state.newProject.area,
          province: state.newProject.province,
          weather_source: state.newProject.weather_source,
          weather_source_type: state.newProject.weather_source_type,
          climate_id: state.newProject.climate_id === 'Año medio'
            ? null : state.newProject.climate_id,
          cultive: {
            crop_id: state.newProject.cultive.crop_id,
            date_init: moment(state.newProject.cultive.date_init).format('YYYY-MM-DD'),
            date_end: moment(state.newProject.cultive.date_end).format('YYYY-MM-DD'),
            crop_type: state.newProject.cultive.crop_type,
            density: null,
          },
          ground: {
            ground_id: state.newProject.ground.ground_id,
            recent_analysis: state.newProject.ground.recent_analysis === 'Yes'
              || state.newProject.ground.recent_analysis,
            previous_analysis: state.newProject.ground.previous_analysis === 'Yes'
              || state.newProject.ground.previous_analysis,
            P: state.newProject.ground.P ? state.newProject.ground.P : 250,
            K: state.newProject.ground.K ? state.newProject.ground.K : 240,
            N: state.newProject.ground.N ? state.newProject.ground.N : 25,
            Mg: state.newProject.ground.Mg ? state.newProject.ground.Mg : 225,
            Ca: state.newProject.ground.Ca ? state.newProject.ground.Ca : 1000,
            Na: state.newProject.ground.Na ? state.newProject.ground.Na : 58,
            ce: state.newProject.ground.ce ? state.newProject.ground.ce : 3,
            P_units: state.newProject.PhosphorusUnit
              ? state.newProject.PhosphorusUnit : state.unit[0].id,
            K_units: state.newProject.potasioUnit ? state.newProject.potasioUnit : state.unit[0].id,
            N_units: state.newProject.NitrogesUnit
              ? state.newProject.NitrogesUnit : state.unit[0].id,
            Mg_units: state.newProject.magnesioUnit
              ? state.newProject.magnesioUnit : state.unit[0].id,
            Ca_units: state.newProject.calcioUnit ? state.newProject.calcioUnit : state.unit[0].id,
            Na_units: state.newProject.sodioUnit ? state.newProject.sodioUnit : state.unit[0].id,
            ce_units: state.newProject.ceFloorUnit
              ? state.newProject.ceFloorUnit : state.unitCe[0].id,
          },
          ground_external: null,
          irrigation: {
            irrigation_id: state.newProject.irrigation.irrigation_id,
            analysis: state.newProject.irrigation.analysis,
            ce: null,
            units_ce: null,
            et0_ecuation: state.newProject.irrigation.equation,
            line_distance: null,
            drip_distance: null,
            caudal: null,
            efficiency: null,
            n_water: null,
            irrigation_open_air: null,
          },
          whitewashed: whitewashedFormat,
          manure,
        };
        try {
          await Api.updateProject(allDataNewProject, state.newProject.id);
        } catch (e) {
          console.error(e);
          return Promise.reject(new Error('¡Upss ha ocurrido un error! Por favor verifique sus datos.'));
        }
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async createDatabaseGround({ dispatch }, newGround) {
      try {
        const xhr = await Api.createDatabaseGround(newGround);
        const ground = JSON.parse(xhr.response);
        dispatch('addElementoInFloor', ground);
        EventBus.$emit('selected-ground', ground.id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async createDatabaseIrrigation({ dispatch }, newIrrigation) {
      try {
        const xhr = await Api.createDatabaseIrrigation(newIrrigation);
        const irrigation = JSON.parse(xhr.response);
        dispatch('addElementoInIrrigation', irrigation);
        EventBus.$emit('irrigation-conf', irrigation.id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async createDatabaseManure({ dispatch }, newManure) {
      try {
        const xhr = await Api.createDatabaseManure(newManure);
        const manure = JSON.parse(xhr.response);
        dispatch('addElementoManure', manure);
        EventBus.$emit('selected-manure', manure.id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseTexture(context) {
      try {
        const xhr = await Api.fetchDatabaseTexture();
        const listTexture = JSON.parse(xhr.response);
        context.commit('fetchListTexture', listTexture);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async createDatabaseTexture({ dispatch }, data) {
      try {
        const xhr = await Api.createDatabaseTexture(data);
        const texture = JSON.parse(xhr.response);
        EventBus.$emit('create-database-texture', texture);
        dispatch('addElementInTextures', texture);
        EventBus.$emit('setTypesFloor');
        EventBus.$emit('selected-texture', texture.id);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimate(context, province) {
      try {
        const xhr = await Api.fetchDatabaseClimate(province);
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimate', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimateSource(context, idSource) {
      try {
        const xhr = await Api.fetchDatabaseClimateSource(idSource);
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimateSource', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchDatabaseClimateSourceMeanYearGh(context) {
      try {
        const xhr = await Api.fetchDatabaseClimateSourceMeanYearGh();
        const climate = JSON.parse(xhr.response);
        context.commit('fetchClimateSource', climate);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async getProjectWithId(context, idProject) {
      try {
        const xhr = await Api.getProject(idProject);
        const project = JSON.parse(xhr.response);
        context.commit('loadProject', project);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async deleteProjectWithId(context, idProject) {
      try {
        await Api.deleteProject(idProject);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
    async fetchProvinces(context) {
      try {
        const xhr = await Api.fetchProvinces();
        const provinces = JSON.parse(xhr.response);
        context.commit('fetchProvinces', provinces);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(Helpers.getError(error));
      }
    },
  },
  mutations: {
    resetProjectGreenHouse(state) {
      Object.assign(state, getDefaultState());
    },
    setNameProject(state, value) {
      if (state.newProject.id && !state.newProject.originalName) {
        state.newProject.originalName = state.newProject.name;
      }
      state.newProject.name = value;
    },
    setSizeGreenHouse(state, value) {
      state.newProject.area = value;
    },
    setProvince(state, value) {
      state.newProject.province = value;
    },
    setStation(state, value) {
      state.newProject.weather_source = value;
    },
    setStationType(state, value) {
      state.newProject.weather_source_type = value;
    },
    setClimateId(state, value) {
      state.newProject.climate_id = value;
    },
    setDateTransplanting(state, value) {
      state.newProject.cultive.date_init = value;
    },
    setPassword(state, value) {
      state.newProject.password = value;
    },
    setSurname(state, value) {
      state.newProject.surname = value;
    },
    setDateEndCrop(state, value) {
      state.newProject.cultive.date_end = value;
    },
    setCropMedium(state, value) {
      state.newProject.cultive.crop_type = value;
    },
    setCrop(state, value) {
      state.newProject.cultive.crop_id = value;
    },
    setFloor(state, value) {
      state.newProject.ground.ground_id = value;
    },
    setEnabledPopUpFloor(state, value) {
      state.enabledPopUpFloor = value;
    },
    setNitricNitrogen(state, value) {
      state.newProject.ground.N = value;
    },
    setPhosphorus(state, value) {
      state.newProject.ground.P = value;
    },
    setAnalysisRecient(state, value) {
      state.newProject.ground.recent_analysis = value;
    },
    setAnalysisPotasio(state, value) {
      state.newProject.ground.K = value;
    },
    setAnalysisPotasioUnit(state, value) {
      state.newProject.potasioUnit = value;
    },
    setAnalysisCalcio(state, value) {
      state.newProject.ground.Ca = value;
    },
    setAnalysisCalcioUnit(state, value) {
      state.newProject.calcioUnit = value;
    },
    setAnalysisMagnesio(state, value) {
      state.newProject.ground.Mg = value;
    },
    setAnalysisMagnesioUnit(state, value) {
      state.newProject.magnesioUnit = value;
    },
    setAnalysisSodio(state, value) {
      state.newProject.ground.Na = value;
    },
    setAnalysisSodioUnit(state, value) {
      state.newProject.sodioUnit = value;
    },
    setAnalysisPreview(state, value) {
      state.newProject.ground.previous_analysis = value;
    },
    setIrrigationConfiguration(state, value) {
      state.newProject.irrigation.irrigation_id = value;
    },
    setWhiteWashing(state, value) {
      state.newProject.whiteWashingSelected = value;
    },
    setEnabledPopUpIrrigation(state, value) {
      state.enabledPopUpIrrigation = value;
    },
    setEnabledPopUpManure(state, value) {
      state.enabledPopUpManure = value;
    },
    setManureSelected(state, value) {
      state.newProject.manure.manure_id = value;
    },
    setAnalysisPhosphorusUnit(state, value) {
      state.newProject.PhosphorusUnit = value;
    },
    setAnalysisNitrogesUnit(state, value) {
      state.newProject.NitrogesUnit = value;
    },
    setCeFloor(state, value) {
      state.newProject.ground.ceFloor = value;
    },
    setCeFloorUnit(state, value) {
      state.newProject.ceFloorUnit = value;
    },
    setAnalysisAvailables(state, value) {
      state.newProject.irrigation.analysis = value;
    },
    setIrrigationFloorUnit(state, value) {
      state.newProject.irrigationFloorUnit = value;
    },
    setApplicationDateManure(state, value) {
      state.newProject.manure.date = value;
    },
    setVolAplicated(state, value) {
      state.newProject.manure.volume = value;
    },
    setDataSourceWhiteWashingAdded(state, value) {
      state.whitewashed = value;
      state.newProject.whitewashed = value;
    },
    setWhitewashed(state, value) {
      state.newProject.whitewashed = value;
    },
    setGroundConcated(state, value) {
      state.ground = value;
    },
    setIrrigationConcated(state, value) {
      state.irrigation = value;
    },
    setManureConcated(state, value) {
      state.manure = value;
    },
    setCont(state, value) {
      state.cont = value;
    },
    setAttachment(state, value) {
      state.attachment = value;
    },
    // Adds.
    addElementoInFloor(state, value) {
      // TODO: SUPONGO QUE HABRÁ QUE ENVIAR LOS DATOS RELLENADOS EN EL POPUP a back.
      state.ground.push({ name: value.name, id: value.id });
    },
    addElementoInIrrigation(state, value) {
      // TODO: SUPONGO QUE HABRÁ QUE ENVIAR LOS DATOS RELLENADOS EN EL POPUP a back.
      state.irrigation.push({ name: value.name, id: value.id });
    },
    addElementoManure(state, value) {
      // TODO: SUPONGO QUE HABRÁ QUE ENVIAR LOS DATOS RELLENADOS EN EL POPUP a back.
      state.manure.push({ name: value.name, id: value.id });
    },
    addElementInTextures(state, value) {
      // TODO: SUPONGO QUE HABRÁ QUE ENVIAR LOS DATOS RELLENADOS EN EL POPUP a back.
      state.typesFloor.push(value);
    },
    setCeWaterGround(state, value) {
      state.newProject.irrigation.ce = value;
    },
    setEquation(state, value) {
      state.newProject.irrigation.equation = value;
    },
    setEnabledPopUpStation(state, value) {
      state.enabledPopUpStation = value;
    },
    // Fetchs
    fetchListCrop(state, value) {
      state.listCropGH = value;
    },
    fetchListTexture(state, value) {
      state.typesFloor = value;
    },
    setDatabaseProvince(state, value) {
      state.province = value;
    },
    fetchClimate(state, value) {
      state.climate = value;
    },
    fetchClimateSource(state, value) {
      state.climateSource = value;
    },
    fetchProvinces(state, value) {
      state.provinces = value;
    },
    // Reset parameters
    resetNewProject(state) {
      state.newProject = {
        id: '',
        name: '',
        type: '',
        area: 0,
        province: '',
        whiteWashingSelected: '',
        weather_source: '',
        climate_id: '',
        cultive: {
          crop_id: '',
          crop_name: '',
          date_init: '',
          date_end: '',
          crop_type: '',
          crop_method: '',
        },
        ground: {
          ground_id: '',
          ground_name: '',
          previous_analysis: '',
          recent_analysis: '',
          N: 0,
          P: 0,
          K: 0,
          Mg: 0,
          Ca: 0,
          Na: 0,
          ce: 0,
          P_units: '',
          K_units: '',
          N_units: '',
          Mg_units: '',
          Ca_units: '',
          Na_units: '',
          ce_units: '',
        },
        irrigation: {
          irrigation_id: '',
          irrigation_name: '',
          analysis: false,
          ce: 0,
          equation: 0,
        },
        whitewashed: [],
        manure: {
          manure_id: '',
          manure_name: '',
          date: '',
          volume: null,
        },
      };
      state.whitewashed = [];
    },
    loadProject(state, value) {
      state.newProject = value;
    },
  },
};
